import { useEffect } from "react"
import ProfileDropdown from "./ProfileDropdown"
import { Link } from "react-router-dom"
import logoDark from "assets/images/logo-dark.png"
import { useAuthenticatedUser } from "auth-provider"
import { useMatch } from "react-router-dom"
import LeftSidebar from "../LeftSidebar"
import classNames from "classnames"
import { useFlags } from "launchdarkly-react-client-sdk"
import ApproveModal from "components/ApproveModal"
import useUserStore from "stores/user"

const titles = {
  "dispatch-center": "Dispatch Center",
  customers: "Customers",
  loads: "Load Management",
  new_loads: "Load Details",
  tracking: "Load Tracking",
  trucks: "Trucks",
  trailers: "Trailers",
  drivers: "Users",
  suppliers: "Suppliers",
  terminals: "Terminals",
  products: "Products",
  loading_numbers: "Loading Numbers",
  reconciliation: "Reconciliation",
  inventory: "Inventory Management",
  "mobile-fueling": "Dispatch Center",
  "customer-groups": "Customer Groups",
}

type ALL_KEYS = "dispatch-center"

const LegacyHeader = () => {
  const { user } = useAuthenticatedUser()
  const flags = useFlags()
  const { customOutageBanner } = useFlags()
  const { isCustomer, isDriver, isCommonCarrier, isCC } = useUserStore((s) => ({
    isCustomer: s.isCustomer,
    isDriver: s.isDriver,
    isCommonCarrier: s.isCommonCarrier,
    isCC: s.isCC,
  }))

  useEffect(() => {
    console.log("Launch Darkly Flags:", { ...flags })
  }, [flags])

  // const canPickCompany = user?.is_superuser
  const matches = useMatch("/:page/*")
  const key = (matches?.params?.page as ALL_KEYS) ?? "dispatch-center"
  // const selected = storedCompany ? parseInt(storedCompany) : undefined
  return (
    <div
      className={classNames(
        "flex items-center fixed w-full z-50 bg-white bootstrap-scope h-[60px] border-b border-border-light",
        !customOutageBanner || customOutageBanner === "disabled"
          ? "top-0"
          : "top-6"
      )}
    >
      <LeftSidebar />

      <Link to="/" className="text-center logo-light overflow-hidden relative">
        <img src={logoDark} alt="DashFuel" height="60" style={{ height: 60 }} />
      </Link>
      <div className="ml-5 w-px bg-border-light self-stretch" />
      {titles[key] ? (
        <span className="ml-6 text-[28px] text-dark-text font-semibold">
          {titles[key]}
        </span>
      ) : null}
      <div className="flex-1" />
      {isCustomer || isDriver || isCommonCarrier || isCC ? null : (
        <ApproveModal />
      )}
      <ProfileDropdown username={user?.full_name ?? ""} />
    </div>
  )
}

export { LegacyHeader }
